import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {performanceComponent} from './PerformanceComponent';
import {PerformanceRiskWidgetModel} from './PerformanceRiskWidgetModel';

export const performanceWidget = hoistCmp.factory({
    model: creates(() => PerformanceRiskWidgetModel),
    render() {
        return panel({
            item: performanceComponent(),
            mask: 'onLoad'
        });
    }
});
